// Import SCSS styles
import styles from './styles.scss';

// Import widget function
import createWidget from './widget.js';

// Execute the widget immediately (IIFE pattern)
(function() {
  createWidget();
})();

